import React, {useCallback, useState, useEffect} from 'react'
import { useHistory } from "react-router";

import { usePersistedState, useActionApi } from "hooks";
import { entities } from "reduxStore";
import Api from "api";

import {
	OverviewStep,
	ExitPopup,
	BackendJob,
	EditPostMode,
	EditedJob,
} from "components/EditJob";
import FixedLoader from 'components/FixedLoader'
import FixedError from 'components/FixedError'

export default function EditJobPostOverviewStep() {
	const history = useHistory()
	const { mode, originalJob } = history.location.state as { mode: EditPostMode, originalJob?: BackendJob }

	const [isExitPopupOpen, setIsExitPopupOpen] = useState(false);

	const [persistedJob, saveJob] = usePersistedState({
		entityName: entities.editedJobPost,
		initialValue: {} as EditedJob,
	})
	
	useEffect(() => {
		if (persistedJob && !persistedJob.availability && persistedJob.id) {
			const fixedJob = {...persistedJob};
			
			if (!fixedJob.availability) {
				fixedJob.availability = [0, 0, 0, 0, 0, 0, 0];
			}
			
			saveJob(fixedJob);
		}
	}, [persistedJob, saveJob]);

	const [jobPostingLoading, jobPostingError, postJobApi] = useActionApi({
		apiMethod: Api.postJob,
		onSuccess: () => {
		history.replace({ pathname: "jobBoard" });
		}
	})
	const [editJobPostingLoading, editJobPostingError, editJobApi] = useActionApi(
		{
			apiMethod: Api.editJob,
			onSuccess: useCallback(() => {
				history.push({ pathname: "jobBoardDetails", state: { job: originalJob } });
			}, [history])
		}
	)

	const onEditJobFlowClose = () => {
		setIsExitPopupOpen(true);
	}

	const onEditJobFlowEdit = () => {
		history.push({ pathname: "editJobFirstStep", state: { mode, originalJob } })
	}
	
	const onEditJobFlowConfirm = () => {
		let job = persistedJob;

		if (mode === EditPostMode.edit) {
			editJobApi(job);
		} else {
			postJobApi(job);
		}
	}

	const onExitPopupClose = () => {
		setIsExitPopupOpen(false);
	}
	const onExitPopupConfirm = () => {
		setIsExitPopupOpen(false);

		if (mode === EditPostMode.edit) {
			history.push({ pathname: "jobBoardDetails", state: { job: originalJob } });
		} else {
			history.replace("jobBoard");
		}
	}

	return (
		<>
			<OverviewStep
				job={persistedJob}
				onEdit={onEditJobFlowEdit}
				onClose={onEditJobFlowClose}
				onConfirm={onEditJobFlowConfirm}
			/>
			<ExitPopup opened={isExitPopupOpen} onConfirm={onExitPopupConfirm} onClose={onExitPopupClose} />
			<FixedLoader loading={jobPostingLoading || editJobPostingLoading} />
			<FixedError error={jobPostingError || editJobPostingError} />
		</>
	)
}
